import { NodeType } from '../IBaseNode';
var ECSNode = /** @class */ (function () {
    function ECSNode(document) {
        this.asc = false;
        this.enabled = true;
        this.orderBy = '';
        if (document) {
            this.name = document.title;
            this.description = document.description;
            this.record = document;
        }
    }
    Object.defineProperty(ECSNode.prototype, "nodeType", {
        get: function () {
            if (this.record) {
                return NodeType.Document;
            }
            else {
                return NodeType.Category;
            }
        },
        enumerable: true,
        configurable: true
    });
    return ECSNode;
}());
export { ECSNode };
